import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module-stocks';
const platform = platformBrowserDynamic();
platform.bootstrapModule(AppModule);